
interface VhostConfig {
    hostname: string;
    node_name: string;
    provider_api: string;
    owner?: string;
    provider_key: string;
    ip?: string;
    tpl?: any;
}

export class VHost {

    public hostname: string;
    public node_name: string;          // tslint:disable-line
    public provider_api: string;       // tslint:disable-line
    public owner: string;              // tslint:disable-line
    public provider_key: string;       // tslint:disable-line
    public ip: string;


    constructor(config: VhostConfig) {
        Object.assign(this, config);
    }
}